import React, {useEffect, useState} from 'react';

/**
 * 단순 라디오 그룹 : radioAttributes를 받아서 라디오를 만들어준다.
 */
const SimpleRadioGroup = ({radioAttributes, target, defaultValue, data, method}) => {
    const [value, setValue] = useState("");

    useEffect(() => {
        setValue(defaultValue);
    }, [defaultValue])

    const handleChange = (e) => {
        const changedValue = e.target.value;
        if (data) {
            data.setData((prev) => ({
                ...prev,
                [target]: typeof prev[target] === 'object'
                    ? { ...prev[target], value: changedValue }
                    : changedValue
            }));
        }
        setValue(changedValue);
        if (method) {
            method(data.data[target].id, changedValue);
        }
    }

    return (
        <div className={"flex mobile-column"}>
            {radioAttributes.length > 0 && radioAttributes.map((item, index) => (
                <div key={index} >
                    <label className={`flex text-gray-700 rounded-md px-3 py-2 ${item.disable ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
                        <input
                            type="radio"
                            name={target}
                            checked={value && value === item.value}
                            onChange={(e) => handleChange(e)}
                            value={item.value}
                            disabled={!!item.disable}
                        />
                        <span className={`pr-2 ${item.className ? item.className : ''} ${item.disable ? 'text-gray-400' : ''}`}>{item.text}</span>
                    </label>
                </div>
            ))}
        </div>
    );
};

export default SimpleRadioGroup;